import axios from 'axios'

export function fetchDataLoggerDevices(companySlug) {
  return (dispatch, getState) => {
    dispatch({
      type: 'DATA_LOGGER_DEVICES_FETCH',
      payload: axios(`/companies/${companySlug}/data_logger_devices`)
    })
  }
}

export function fetchChildCompanyAndUnallocatedDataLoggerDevices(companySlug) {
  return (dispatch, getState) => {
    dispatch({
      type: 'CHILD_COMPANY_AND_UNALLOCATED_DATA_LOGGER_DEVICES_FETCH',
      payload: axios(`/companies/${companySlug}/child_company_and_unallocated_data_logger_devices`)
    })
  }
}




// WEBPACK FOOTER //
// ./src/actions/DataLoggerDeviceActions.js